import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LastFilterUpdatedState } from '../../../../../interfaces/src/lib/types/index';

const initialState: LastFilterUpdatedState = {
  filterType: '',
};

const lastFilterUpdatedSlice = createSlice({
  name: 'lastFilterUpdated',
  initialState,
  reducers: {
    setLastFilterUpdated: (state: LastFilterUpdatedState, action: PayloadAction<string>) => {
      state.filterType = action.payload;
    },
  },
});

export const { setLastFilterUpdated } = lastFilterUpdatedSlice.actions;
export const lastFilterUpdatedReducer = lastFilterUpdatedSlice.reducer;
